(() => {
  angular
    .module('gm.common.services')
    .factory('GmyStorage', GmyStorage);

  function GmyStorage(
    $window
  ) {
    'ngInject';

    const isLocalStorageAvailable = (() => {
      try {
        $window.localStorage.setItem('storageTest', '');
        $window.localStorage.removeItem('storageTest');
      } catch (error) {
        return false;
      }
      return true;
    })();

    const isSessionStorageAvailable = (() => {
      try {
        $window.sessionStorage.setItem('storageTest', '');
        $window.sessionStorage.removeItem('storageTest');
      } catch (error) {
        return false;
      }
      return true;
    })();

    return {
      clearLocal,
      clearSession,
      getLocalItem,
      getSessionItem,
      keyLocal,
      keySession,
      lengthLocal,
      lengthSession,
      removeLocalItem,
      removeSessionItem,
      setLocalItem,
      setSessionItem,
    };

    function clearLocal() {
      return (isLocalStorageAvailable) ? $window.localStorage.clear() : '';
    }

    function clearSession() {
      return (isSessionStorageAvailable) ? $window.sessionStorage.clear() : '';
    }

    function getLocalItem(key) {
      return (isLocalStorageAvailable) ? $window.localStorage.getItem(key) : '';
    }

    function getSessionItem(key) {
      return (isSessionStorageAvailable) ? $window.sessionStorage.getItem(key) : '';
    }

    function keyLocal(key) {
      return (isLocalStorageAvailable) ? $window.localStorage.key(key) : '';
    }

    function keySession(key) {
      return (isSessionStorageAvailable) ? $window.sessionStorage.key(key) : '';
    }

    function lengthLocal() {
      return (isLocalStorageAvailable) ? $window.localStorage.length : 0;
    }

    function lengthSession() {
      return (isSessionStorageAvailable) ? $window.sessionStorage.length : 0;
    }

    function removeLocalItem(key) {
      return (isLocalStorageAvailable) ? $window.localStorage.removeItem(key) : '';
    }

    function removeSessionItem(key) {
      return (isSessionStorageAvailable) ? $window.sessionStorage.removeItem(key) : '';
    }

    function setLocalItem(key, value) {
      return (isLocalStorageAvailable) ? $window.localStorage.setItem(key, value) : '';
    }

    function setSessionItem(key, value) {
      return (isSessionStorageAvailable) ? $window.sessionStorage.setItem(key, value) : '';
    }
  }
})();
